import { render, staticRenderFns } from "./oilorderItem.vue?vue&type=template&id=4b6ee297&scoped=true&"
import script from "./oilorderItem.vue?vue&type=script&lang=js&"
export * from "./oilorderItem.vue?vue&type=script&lang=js&"
import style0 from "./oilorderItem.vue?vue&type=style&index=0&id=4b6ee297&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b6ee297",
  null
  
)

export default component.exports